import { useMutation } from 'react-query';
import { useError } from '../../../common/Errors/ErrorContext/ErrorContext';
import usePlanStore from '../../../../../../store/planStore';
import { bookMetaPoll } from '../../../../../../api/services/mediaPlanning/bookMetaPoll';

const useBookMetaPoll = (getMetaPredictionStatuses: () => void) => {
  const { countryForms, updateMetaConfig, storeDigitalCountryFormState } =
    usePlanStore();
  const { showError } = useError();

  const isAnyMetaNotReserved = Object.values(countryForms).some(
    (country) => country.metaConfig?.reservationStatus !== 'reserved'
  );

  const {
    mutate: bookMetaPollTrigger,
    mutateAsync: asyncBookMetaPollTrigger,
    data: response,
    isLoading,
    isError,
    error,
  } = useMutation(
    async ({ jobId }: { jobId: string | null }) => {
      return bookMetaPoll(jobId);
    },
    {
      onError: (errorHandler: any) => {
        const errorMessage =
          errorHandler?.response?.data?.message ||
          errorHandler.message ||
          'Unknown error';
        showError(errorMessage);

        if (getMetaPredictionStatuses && isAnyMetaNotReserved) {
          getMetaPredictionStatuses();
        }
      },

      onSuccess: (res) => {
        if (getMetaPredictionStatuses && isAnyMetaNotReserved) {
          getMetaPredictionStatuses();
        }

        res.data.results?.forEach(({ value }) => {
          if (value && value.country) {
            updateMetaConfig(value?.country, {
              isGoldenRuleMet: value?.isGoldenRuleMet,
              reservationStatus: value?.status,
            });
            storeDigitalCountryFormState(value?.country);
          }
        });
      },
    }
  );

  return {
    bookMetaPollTrigger,
    asyncBookMetaPollTrigger,
    data: response,
    isLoading,
    isError,
    error,
  };
};

export default useBookMetaPoll;
